import React from 'react';

import "./Section.css";
import "./Section";

export default function Section(props) {
  return <div className={`${props.className} portfolio-screen-section mdl-typography--text-center`}>
      {props.children}
  </div>
}



// WEBPACK FOOTER //
// ./src/Section/Section.js